// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".faq-grid[data-v-112128ac]{grid-gap:1.25rem;align-items:start;display:grid;gap:1.25rem;grid-template-columns:repeat(2,1fr)}@media (max-width:768px){.faq-grid[data-v-112128ac]{grid-template-columns:1fr}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
